import { z } from 'zod'

//  import { createBasicTaskHandlerSchema } from 'modules/procurement/components/procurementTypes/Workflows/sidePanels/schemas/basicTaskHandler'
import { nodeSidepanelSchema } from './nodeSidepanelSchema'

export type TaskHandlerType = 'create_manual_task'

const createTaskFormSchema = () => {
  return nodeSidepanelSchema.extend({
    nodeType: z.literal('task'),
    nodeData: z.object({
      handlerType: z.string(),
      payload: z.object({}),
    }),
  })
}

// Export the schema instance for convenience (created lazily on first use)
export const taskFormSchema = createTaskFormSchema()

export type TaskFormSchema = z.infer<typeof taskFormSchema>
